// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, createCompanyApi } from "../utils/Constants";

export const createCompany = createAsyncThunk(
  "createCompany",
  async (payload) => {
    try {
      const token = localStorage.getItem("token"); 
      const config = {
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          "Content-Type": "application/json",
        },
        mode: "no-cors",
      };

      const response = await axios.post(
        ApiBaseUrl + createCompanyApi,
        payload,
        config
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
);

const CreateCompanySlice = createSlice({
  name: "createCompanyReducer",

  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearDataCreateCompany: (state) => {
      state.data = null;
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCompany.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(createCompany.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearDataCreateCompany } = CreateCompanySlice.actions;
export default CreateCompanySlice.reducer;
